import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateVoucherConfig} from '../api';
import {QUERY__VOUCHER_CONFIG, QUERY__VOUCHER_CONFIGS} from '../queryKeys';

export const useUpdateVoucherConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVoucherConfig,
    onSuccess: (_, {id}) => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__VOUCHER_CONFIGS],
      });
      void queryClient.invalidateQueries({
        queryKey: [QUERY__VOUCHER_CONFIG, id],
      });
    },
  });
};
